<template>
  <modal
    name="gifs-modal"
    height="auto"
    width="60%"
  >
    <div class="flex items-center w-full justify-items-center">
      <video
        class="flex justify-center w-full bg-cover"
        :src="`/videos/onboarding.mp4`"
        autoplay
        loop
        muted
      />
    </div>
    <div class="flex justify-center w-full">
      <button
        class="px-4 py-2 my-2 text-sm leading-5 text-center text-white rounded bg-sc-blue hover:text-white"
        @click="connectAccount()"
      >
        {{ $t('message.settings.accountsTab.connectAccount') }}
      </button>
    </div>
  </modal>
</template>
<script>
export default {
  methods: {
    show() {
      this.$modal.show('gifs-modal');
    },
    connectAccount() {
      this.$emit('connect');
      this.$modal.hide('gifs-modal');
    },
  },
};
</script>
